module.exports = __webpack_public_path__ + "img/Pdf-icon.aeef3e77.svg";